<template>
  <div class="mm_body">
    <mmheader :mm-site-url="mm_site_url"></mmheader>
    <div style="clear: both;"></div>
    <section class="container" style="padding-top: 72px !important;">
      <div class="row justify-content-center mb-3">
        <div class="row justify-content-center mb-3">
          <div class="col-md-8 col-xs-11">
            <div class="mt-4 text-center">
              <img src="@/assets/mm_logo_small.png" alt="" width="75">
            </div>
            <div class="h5 mt-3 mb-2 text-center font-weight-bold">Select a subscription to that fits your team size.</div>
            <div class="mt-5 mb-4 text-center">
              <flash-message autoHide variant="success"></flash-message>
              <b-alert
                :show="dismissCountDown"
                dismissible
                variant="danger"
                @dismissed="dismissCountDown=0"
                @dismiss-count-down="countDownChanged"
                >
                {{ warning_message }}
              </b-alert>
            </div>


          </div>

          <div class="col-md-8 col-xs-11">
            <div class="border rounded shadow px-4 py-2">
              <div class="row">
                <div class="col-5">
                  <div class="font-weight-bold h6 mb-2">{{ accountName }}</div>
                  <div class="font-weight-bold h6 mb-2">{{ org_address }}{{ mailing_address_2 != '' ? ', ' + mailing_address_2 : '' }}</div>
                  <div class="font-weight-bold h6 mb-2">{{ org_city }}, {{ org_state }} {{ org_zip }}</div>
                </div>
                <div class="col-7">
                  <div class="font-weight-bold h6 mb-2 text-right">{{ primaryUserName }}</div>
                  <div class="h6 mb-2 text-right text-break">{{ primaryUserEmail }}</div>
                  <div class="h6 mb-2 text-right">{{ primaryPhone }}</div>
                </div>


              </div>
              <div class="row">
                <div class="col-8">
                  &nbsp;
                </div>
                <div class="col-4">
                  <div class="text-right">
                    <a class=""><i class="fa fa-pencil" aria-hidden="true" style="color: #00ACEE; cursor: pointer;" @click="editPageRedirect()"></i></a>
                  </div>
                </div>
              </div>

            </div>




            <div class="h3 float-left col-6 p-0" style="top: 47px; z-index: 9998;">
              Subscription
            </div>
            <div class="">
              <b-card no-body>
                <b-tabs card>
                  <b-tab title="Monthly" @click="selectType('monthly')" :active="type == 'monthly'">
                    <b-card-text>


            <div class="monthly">
            <div class="border rounded shadow px-4 py-3 mb-4 subscription_box" v-for="(list, index) in subscriptions_monthly" :class="list.id == packageId ? 'black-border' : ''" :key="'m' + index">
              <div class="row">
                  <div class="col-7" style="margin-top: -10px !important;">
                    <div class="custom-control custom-radio custom-control-inline" style="margin-right: 0px !important;">
                    <input
                      type="radio"
                      v-bind:id="'is_primary_' + index" 
                      :ref="'is_primary_' + index"
                      v-bind:name="'is_primary[' + index + ']'"
                      v-model="list.isSelected"
                      :checked="list.checked"
                      @click="clickPrimary(index, 'monthly')"
                      :value="1" class="custom-control-input" style="margin-top: -2px !important; height: 10px;">
                    <label 
                      class="custom-control-label" 
                      :for="'is_primary_' + index" style="margin-top: 9px !important;"></label>
                  </div>

                    {{ list.packageName }}
                  </div>
                  <div class="col-5 text-right pr-4">
                    &#36;{{ list.packagePrice }}/billed monthly
                  </div>
              </div>
              <div class="row" >
                <div class="col-7 seat_qty" >
                  &nbsp;
                </div>
                <div class="col-5 text-right annual pr-4" >
                  Annual subscription
                </div>
              </div>
              <div class="row" >
                <div class="col-8 seat_qty" >
                  {{ list.packageQty }}
                </div>
                <div class="col-4 text-right seat_qty pr-4 bold" v-if="list.packagediscount > 0">
                  ({{ list.packagediscount }}% Savings)
                </div>
              </div>
              <div class="clear"></div>
            </div>

            </div>


                    </b-card-text>
                  </b-tab>
                  <b-tab title="Annual" @click="selectType('yearly')" :active="type == 'yearly'">
                    <b-card-text>

            <div class="yearly">
            <div class="border rounded shadow px-4 py-3 mb-4 subscription_box" v-for="(list, index) in subscriptions_yearly" :class="list.id == packageId ? 'black-border' : ''" :key="'y' + index">
              <div class="row">
                  <div class="col-7" style="margin-top: -10px !important;">
                    <div class="custom-control custom-radio custom-control-inline" style="margin-right: 0px !important;">
                      <input
                        type="radio"
                        v-bind:id="'is_monthly_primary_' + index" 
                        :ref="'is_monthly_primary_' + index"
                        v-bind:name="'is_monthly_primary_[' + index + ']'"
                        v-model="list.isSelected"
                        :checked="list.checked"
                        @click="clickPrimary(index, 'yearly')"
                        :value="1" class="custom-control-input" style="margin-top: -2px !important; height: 10px;">
                      <label 
                        class="custom-control-label" 
                        :for="'is_monthly_primary_' + index" style="margin-top: 9px !important;"></label>
                    </div>
                    {{ list.packageName }}
                  </div>
                  <div class="col-5 text-right pr-4">
                    &#36;{{ list.packagePrice }}/billed annually
                  </div>
              </div>
              <div class="row pt-2" >
                <div class="col-8 seat_qty" >
                  {{ list.packageQty }}
                </div>
                <div class="col-4 text-right seat_qty pr-4 bold" v-if="list.packagediscount > 0">
                  ({{ list.packagediscount }}% Savings)
                </div>
              </div>
              <div class="clear"></div>
            </div>

            </div>

                    </b-card-text>
                  </b-tab>
                </b-tabs>
              </b-card>
            </div>




            <div class="text-center mt-4">
              <button type="submit" class="btn btn-lg font-weight-bold text-center px-5" @click="processPayment()" :disabled="!isFormValid || disable_purchase_btn" :class="isFormValid ? 'btn-blue' : 'btn-blue-purchase-disabled'">Select Subscription</button>
            </div>

            <div class="text-center mt-2 mb-5">
              <a class="small font-weight-bold" style="text-decoration: underline; color: #002F42; cursor: pointer;" @click="loginRedirect()">Select Subscription Later</a>
            </div>

          </div>
        </div>
      </div>
    </section>
    <mmfooter :mm-site-url="mm_site_url"></mmfooter>
  </div>
</template>

<script>
import axios from 'axios';
import mmheader from '@/components/mm_header';
import mmfooter from '@/components/mm_footer';
import router from '../../router/index.js';

export default {
  data() {
    return {
      mm_site_url: process.env.MM_SITE_URL,
      nameOnCard: '',
      cardNumber: '',
      expMonth: '',
      expYear: '',
      cvvValue: '',
      year_options: [],
      is_billing_address_same: 1,
      country_options: [],
      state_options: [],
      org_address: '',
      org_country: 'US',
      mailing_address_2: '',
      org_city: '',
      org_state: '',
      org_zip: '',
      billing_name: '',
      billing_address: '',
      billing_address2: '',
      billing_city: '',
      billing_state: '',
      billing_country: '',
      billing_zip: '',
      total_amt: 0,
      subscriptionId: '',
      subscriptionPrice: '',
      subscriptions_yearly: [],
      subscriptions_monthly: [],
      packageId: '',
      defaultpackageId: '',
      unit: 1,
      type: 'yearly',
      accountName: '',
      primaryUserName: '',
      primaryUserEmail: '',
      primaryPhone: '',
      success_message: '',
      warning_message: '',
      dismissCountDown: 0,
      disable_purchase_btn: false,      
    }
  },
  components: {
    mmheader,
    mmfooter,
  },
  computed: {
    isFormValid() {
      if (this.packageId > 0) {
        return true;
      }
      return false;
    }
  },
  methods: {
    selectType(type) {
      this.type = type;
      this.packageId = this.defaultpackageId;
    },
    editPageRedirect() {
      this.$router.push({ name: 'mmCreateAccountEditSubscription'});
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    clickPrimary: function(index, type) {
      if(type == 'yearly') {
        for(var i=0; i < this.subscriptions_yearly.length; i++) {
          this.subscriptions_yearly[i].isSelected = 0;
          this.subscriptions_yearly[i].checked = false;
        }
        this.subscriptions_yearly[index].isSelected = 1;
        this.subscriptions_yearly[index].checked = true;
        this.packageId = this.subscriptions_yearly[index].id;
      }
      else {
        for(var i=0; i < this.subscriptions_monthly.length; i++) {
          this.subscriptions_monthly[i].isSelected = 0;
          this.subscriptions_monthly[i].checked = false;
        }
        this.subscriptions_monthly[index].isSelected = 1;
        this.subscriptions_monthly[index].checked = true;
        this.packageId = this.subscriptions_monthly[index].id;
        }
    },
    loginRedirect() {
      this.$store.dispatch('create_account', '');              
      this.$store.dispatch('create_account_obj', '');              
      router.push("/login");

    },
    billingAddressChange(event) {
      if(event.target.checked == true) {
        this.billing_address = this.org_address;
        this.billing_country = this.org_country;
        this.billing_address2 = this.mailing_address_2;
        this.billing_city = this.org_city;
        this.billing_state = this.org_state;
        this.billing_zip = this.org_zip;
        this.billing_name = this.primaryUserName;
      }
      else {
        this.billing_address = '';
        this.billing_country = '';
        this.billing_address2 = '';
        this.billing_city = '';
        this.billing_state = '';
        this.billing_zip = '';
        this.billing_name = '';
      }
    },
    onChangePrice() {
      //this.total_amt = Math.round(parseInt((this.unit*899.00) + 3999.00), 2);
    },
    processPayment() {
      let packageId = this.packageId;
      let type = this.type;
      this.$store.dispatch('create_account_billing', { packageId, type })
      this.$router.push({ name: 'mmCreateAccountPurchase'})
    },

    getExpiryYears() {
      this.year_options = [
        { value: '', text: 'Year' },
      ];       
      var min = new Date().getFullYear()
      var max = min + 20;
      for (var i = min; i <= max; i++) {
        var yoptions = { value: i, text: i };
        this.year_options.push(yoptions);
      }
    },
    getPostalCodeRegex: function () {
      if (this.billing_country == "US") {
        return /^[0-9]{5}(?:-[0-9]{4})?$/;
      } else if (this.billing_country == "CA") {
        return /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/;
      }
      return /./;
    },
    getCountryLists: function () {
      axios.get('/custom/account-create-country-lists', {})
        .then(response => {
          this.country_options = response.data;
        })
        .catch(function (error) {});
    },
    getStateLists: function (CountryCode) {
      this.org_state = '';
      if (CountryCode == '') {
        CountryCode = null;
      }
      axios.get('/custom/get-state-lists/' + CountryCode, {})
        .then(response => {
          response.data[0].text = "Select State / Province";
          this.state_options = response.data;
        })
        .catch(function (error) {});
      },
      getSubscriptionLists() {

        axios('/custom/get-account-seat-subscription-lists/'+ this.$store.state.create_account_accountId,
        {
          method: 'GET'        
        })
        .then(resp => {        
          this.subscriptions_yearly = resp.data.subscriptions_yearly;
          this.subscriptions_monthly = resp.data.subscriptions_monthly;
          if(this.$store.state.create_account_billing_type) {
            this.type = this.$store.state.create_account_billing_type;
          }
          if(this.$store.state.create_account_billing_packageId) {
            this.packageId = this.$store.state.create_account_billing_packageId;
          }
          else {
            this.packageId = resp.data.packageId;  
          }
          if(this.$store.state.create_account_billing_type == 'yearly') {
            for(var i=0; i < this.subscriptions_yearly.length; i++) {
              this.subscriptions_yearly[i].isSelected = 0;
              this.subscriptions_yearly[i].checked = false;
              if(this.packageId == this.subscriptions_yearly[i].id) {
                this.subscriptions_yearly[i].isSelected = 1;
                this.subscriptions_yearly[i].checked = true;
              }
            }
          }
          else if(this.$store.state.create_account_billing_type == 'monthly') {
            for(var i=0; i < this.subscriptions_monthly.length; i++) {
              this.subscriptions_monthly[i].isSelected = 0;
              this.subscriptions_monthly[i].checked = false;
              if(this.packageId == this.subscriptions_monthly[i].id) {
                this.subscriptions_monthly[i].isSelected = 1;
                this.subscriptions_monthly[i].checked = true;
              }
            }
          }

          this.defaultpackageId = resp.data.packageId;
          this.total_amt = resp.data.total_amt;
          this.subscriptionId = resp.data.subscriptionId;
          this.unit = resp.data.unit;
        })
        .catch(() => {
        });      

      },

  },
  created() {
    if(!this.$store.state.create_account_email) {
      this.$router.push({ name: 'mmcreateaccount'})
    }
    this.getExpiryYears();
    this.getCountryLists();
    this.getSubscriptionLists();
    this.getStateLists(this.org_country);
    //this.total_amt = Math.round(parseInt((this.unit*899.00) + 3999.00), 2);

      axios.get('/custom/get-account-user-details', {
        params: {
          account_id: this.$store.state.create_account_accountId,
          user_id: this.$store.state.create_account_uid,
        }

      })
      .then(response => {
        this.org_address = response.data.account_address;
        this.org_country = response.data.account_country;
        this.mailing_address_2 = response.data.account_address2;
        this.org_city = response.data.account_city;
        this.org_state = response.data.account_state;
        this.org_zip = response.data.account_zip;
        this.billing_address = response.data.account_address;
        this.billing_country = response.data.account_country;
        this.billing_address2 = response.data.account_address2;
        this.billing_city = response.data.account_city;
        this.billing_state = response.data.account_state;
        this.billing_zip = response.data.account_zip;
        this.primaryUserName = response.data.primary_user_name;
        this.billing_name = response.data.primary_user_name;
        this.primaryUserEmail = response.data.primary_user_email;
        this.accountName = response.data.account_name;
        this.primaryPhone = response.data.primary_phone;

      })
      .catch(function (error) {

      });


  },
}
</script>

<style scoped>
.mm_body {
  /* font-size: 20px !important; */
  color: #002F42;
  max-width: 2400px;
  margin: auto;
  font-family: "proxima-nova", Arial, verdana !important;
}
.btn-blue {
  font-size: 20px;
  padding: 5px 30px 5px 30px;
  border-radius: 5px;
  color: white;
}
.btn-blue:hover,
.btn-blue-purchase-disabled:hover {
  color: white;
}
.btn-blue-purchase-disabled {
  font-size: 20px;
  padding: 5px 30px 5px 30px;
  background-color: #b8b8b8 !important;
  border: 1px solid #b8b8b8 !important;
  border-radius: 5px;
  color: white;
}
.custom-select {
  font-size: 1rem !important;
  height: calc(1.5em + 0.75rem + 2px) !important;
}
.rounded {
    border-radius: 1rem !important;
}
.annual {
  font-size: 11px;
}
.black-border {
  border: 1px solid #002F42 !important;
}
</style>
<style>
.card-header-tabs {
  width: 50%;
  float: right;
  margin: 0 !important;
  text-align: right;
  margin-bottom: 20px !important;
  box-shadow: 0 0px 5px rgba(0,0,0,.15)!important;
  border-radius: 1rem !important;
  padding: 3px 3px 4px 3px !important;
  margin-right: -20px !important;
}
.card-header-tabs li {
  width: 50%;
}
.nav-tabs .nav-link:hover {
  padding: 1px 8px !important;
  background-color: #FFF !important;
  border: 0 !important;
  font-weight: normal;
  color: #002F42 !important;
}
.nav-link, .nav-tabs .nav-item.show .nav-link, .nav-link, .nav-tabs .nav-item.show .nav-link:hover {
  padding: 1px 8px !important;
  background-color: #FFF !important;
  border: 0 !important;
  font-weight: normal;
}
.card-header li a, .card-header li a:hover {
    font-weight: normal !important;
    font-size: 13px !important;
    text-align: center;
}
.nav-tabs .nav-link.active {
  background-color: #082F42 !important;
  padding: 1px 8px !important;
  border-radius: 1rem !important;
  font-weight: normal;
  color: #FFF !important;
}
.card-header {
  border: 0 !important;
}
.tab-content {
  float: none;
  clear: both;
}
</style>


// WEBPACK FOOTER //
// src/components/create_account/subscriptionlists.vue